import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { TextField, Typography } from '@mui/material';
import { Button } from '../../../../components';

import { AquaLogo } from '@wave-engagement/wave-react';
import { forgotPasswordRequest } from '../../../../api';
import { useAlerts } from '../../../../alerts';

const ForgotPasswordRequest = () => {
  const { setSuccess, setError, clearErrors } = useAlerts();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return () => clearErrors();
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    forgotPasswordRequest({ email }).then(() => {
      setIsLoading(false);
      setSuccess('If an account with that email address exists, an email has been sent with a verification link.');
      navigate('/auth/login');
    }).catch((error) => {
      setIsLoading(false);
      setError(error ?? 'An error occurred while trying to reset your password.');
    });
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '3em' }}>
        <img src={AquaLogo} alt='Wave Engagement Logo' style={{ width: '100%', maxWidth: '300px', objectFit: 'contain', marginTop: '3em' }} />
      </div>
      <Typography variant='h1' gutterBottom>Forgot Password</Typography>

      <form onSubmit={onSubmit}>
        {/* Email */}
        <TextField
          required
          label='Email'
          onChange={(e) => setEmail(e.target.value)}
          disabled={isLoading}
          variant='filled'
          style={{
            width: '100%',
            marginBottom: '0.5em'
          }}>
        </TextField>

        {/* Submit */}
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Button
            type='submit'
            style={{ width: '48%', marginTop: '1em' }}
            isLoading={isLoading}>
            Submit
          </Button>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '.5em' }}>
          Ready to log in?&nbsp;<Link to='/auth/login'>Click here.</Link>
        </div>

      </form>
    </div>
  );
}
export default ForgotPasswordRequest;